import moment, { Moment } from 'moment';

const formatDates = (
  fromDate: Moment | undefined | null,
  toDate: Moment | undefined | null,
  country: string,
  format: string | undefined | null
) => {
  const [fromYear, fromMonth, fromDay] = moment(fromDate).toArray();
  const [toYear, toMonth, toDay] = moment(toDate).toArray();

  let formattedFromDate;
  let formattedToDate;

  const USCAFromDateFormat = `${
    fromMonth + 1 < 10 ? `0${fromMonth + 1}` : fromMonth + 1
  }/${fromDay < 10 ? `0${fromDay}` : fromDay}/${fromYear}`;

  const USCAToDateFormat = `${
    toMonth + 1 < 10 ? `0${toMonth + 1}` : toMonth + 1
  }/${toDay < 10 ? `0${toDay}` : toDay}/${toYear}`;

  const AUFromDateFormat = `${fromDay < 10 ? `0${fromDay}` : fromDay}/${
    fromMonth + 1 < 10 ? `0${fromMonth + 1}` : fromMonth + 1
  }/${fromYear}`;

  const AUToDateFormat = `${toDay < 10 ? `0${toDay}` : toDay}/${
    toMonth + 1 < 10 ? `0${toMonth + 1}` : toMonth + 1
  }/${toYear}`;

  if (!format) {
    if (country === 'AU') {
      formattedFromDate = AUFromDateFormat;
      formattedToDate = AUToDateFormat;
    } else {
      formattedFromDate = USCAFromDateFormat;
      formattedToDate = USCAToDateFormat;
    }
  } else {
    if (format === 'AU') {
      formattedFromDate = AUFromDateFormat;
      formattedToDate = AUToDateFormat;
    } else {
      formattedFromDate = USCAFromDateFormat;
      formattedToDate = USCAToDateFormat;
    }
  }
  return {
    formattedFromDate,
    formattedToDate,
  };
};

export default formatDates;
